import React from "react";

import { phoneToHuman } from "../../lib/phoneToHuman";
import "./PhoneNumber.scss";

export interface PhoneNumberProps {
  phoneNumber: string | null | undefined;
  className?: string;
}

export function PhoneNumber(props: PhoneNumberProps) {
  const { phoneNumber, className } = props;

  if (!phoneNumber) {
    return <span className={className}></span>;
  }

  return <span className={className}>{phoneToHuman(phoneNumber)}</span>;
}
